import {
  isIOS,
  isAndroid,
} from '@/const/common'



window.tjCallbackMethodToken = 0
window.tjCallbackMap = {}

/**
 * 调用原生方法
 * @param {*} name 方法名
 * @param {*} params 参数
 * @param {*} cbk 回调
 * native传给js的值格式约定：
 result:
 {
  data:{
    k1:v1,
    k2:v2,
    ...
  },
  msg:msg,//附带的信息
  code:0-失败,1- 成功
 }
 */
export const tjCallNative = (name, params, cbk) => {
  console.log('tj调用 方法名:', name, '方法参数:', params, '回调:', cbk)

  /**
   * tj回调
   * @param {*} extra
   * @param {*} result
   */
  function tjCallback(extra, result) {
    let callbackMethod = window.tjCallbackMap[extra]
    window.tjCallbackMap[extra] = null
    console.log("rr1:" + JSON.stringify(result))
    console.log('callbackMethod', callbackMethod)
    if (callbackMethod) {
      let res = result.data
      // if (isAndroid) {
      //   res = result.data
      // }
      // if (isIOS) {
      //   res = result.data
      // }
      callbackMethod && callbackMethod(res)
    }
  }

  window.tjCallback = tjCallback

  /**
   * 组合参数
   * @param {*} obj
   * @param {*} callback
   */
  function composeParams(obj = null, callback = null) {
    let callbackMethodToken = null
    if (callback) {
      callbackMethodToken = (window.tjCallbackMethodToken++).toString()
      window[`tjCallback${callbackMethodToken}`] = callback
      window.tjCallbackMap[callbackMethodToken] = window[`tjCallback${callbackMethodToken}`]
    }
    return JSON.stringify({
      data: obj,
      callback: 'tjCallback',
      extra: callbackMethodToken,
    })
  }

  let tjParams = composeParams(params, cbk)
  console.log('调用参数:' + tjParams)
  if (isAndroid && window.tj) {
    let _method = window.tj[name]
    _method && window.tj[name](tjParams)
  } else if (isIOS && window.webkit) {
    let _method = window.webkit.messageHandlers[name]
    _method && window.webkit.messageHandlers[name].postMessage(tjParams)
  }
}

export const nativeCall = (nameParams, params, callback = null) => {
  let name = typeof nameParams === 'string' ? nameParams : ''
  tjCallNative(name, params, callback)
}
